import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper'
import 'swiper/css';

import { DivCarrosel } from './style';

import slide1 from '../img/Carrossel1.jpg';
import slide2 from '../img/Carrossel2.jpg';
import slide3 from '../img/Carrossel3.jpg';
import slide4 from '../img/Carrossel4.jpg';
import slide5 from '../img/Carrossel5.jpg';

export const Carrosel = () => {

    return (

        <DivCarrosel>
            <Swiper
                slidesPerView={1}
                loop={true}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                modules={[Autoplay]}
                className="swiper"
            >
                <SwiperSlide><img src={slide1} alt='seja bem vindo' /></SwiperSlide>
                <SwiperSlide><img src={slide2} alt='rótulos, etiquetas adesivas e tags' /></SwiperSlide>
                <SwiperSlide><img src={slide3} alt='nossas etiquetas' /></SwiperSlide>
                <SwiperSlide><img src={slide4} alt='assistência técnica' /></SwiperSlide>
                <SwiperSlide><img src={slide5} alt='promoções' /></SwiperSlide>
            </Swiper>
        </DivCarrosel>
    )
}
